import { Copy } from "@phosphor-icons/react";

const Cmd = ({ id, text, onCopy }) => (
  <div className="flex gap-2 items-start mt-2">
    <code className="font-mono text-[11px] sm:text-xs bg-black text-[#7CFFB2] px-3 py-2 flex-1 break-all" data-testid={`watcher-cmd-${id}`}>{text}</code>
    <button onClick={() => onCopy(text)} className="btn-flat-outline" data-testid={`watcher-copy-cmd-${id}`}><Copy weight="bold" size={16} /></button>
  </div>
);

export function WatcherSteps({ uploadKey, onCopy }) {
  const key = uploadKey || "aiis_YOUR_KEY";
  const run = "powershell -ExecutionPolicy Bypass -File .\\aiis-watcher.ps1";
  return (
    <ol className="mt-5 space-y-5 text-sm" data-testid="watcher-steps">
      <li>
        <p className="font-display font-bold">1. SAVE THE KEY ON THIS PC (ONCE)</p>
        <p className="text-neutral-600 text-xs">Open PowerShell in the folder where you saved the script, then run (open a new window afterwards):</p>
        <Cmd id="setx" text={`setx AIIS_UPLOAD_KEY "${key}"`} onCopy={onCopy} />
      </li>
      <li>
        <p className="font-display font-bold">2. RUN THE SMOKE TEST (UNDER A MINUTE)</p>
        <p className="text-neutral-600 text-xs">Uploads a tiny test photo with fake GPS, confirms it reached an AERIAL session, then deletes it. Ends with PASS or FAIL.</p>
        <Cmd id="smoke" text={`${run} -SmokeTest`} onCopy={onCopy} />
      </li>
      <li>
        <p className="font-display font-bold">3. START WATCHING</p>
        <p className="text-neutral-600 text-xs">Copy SD-card files into the folder (subfolders like DCIM\100MEDIA are included). JPG, JPEG and DNG are uploaded once each file has finished copying, then renamed SYNCED_… so they are never sent twice. Interrupted uploads continue where they stopped. Uploads 3 photos at a time; add <span className="font-mono">-Parallel 6</span> on fast connections or <span className="font-mono">-Parallel 1</span> on slow ones.</p>
        <Cmd id="watch" text={`${run} -WatchPath C:\\DroneDumps`} onCopy={onCopy} />
      </li>
      <li>
        <p className="font-display font-bold">4. START WITH THE PC (OPTIONAL)</p>
        <p className="text-neutral-600 text-xs">Open PowerShell as Administrator (right-click → Run as administrator) in the script folder and run this once. The watcher then runs hidden in the background, starts every time Windows boots (even before anyone signs in), restarts itself if it stops, and shows up in Status above.</p>
        <Cmd id="install" text={`${run} -UploadKey ${key} -WatchPath C:\\DroneDumps -Install`} onCopy={onCopy} />
        <p className="text-neutral-600 text-xs mt-2">To stop it starting with the PC:</p>
        <Cmd id="uninstall" text={`${run} -Uninstall`} onCopy={onCopy} />
      </li>
      <li className="text-xs text-neutral-600 border-l-4 border-black pl-3">
        Log file: <span className="font-mono">C:\DroneDumps\aiis-watcher.log</span>. Requires Windows 10/11 (built-in PowerShell). If Windows blocks the download, right-click the file → Properties → Unblock. Revoke the key here at any time to stop a watcher.
      </li>
    </ol>
  );
}
